<template>
    <div>
        <Topheader></Topheader>
        <div class="w1100">
            <div class="info-body">
                <div class="info-left">
                    <el-image class="big-img" fit="scale-down" :src="info.signboard.imgList1[showIndex].img.url"></el-image>
                </div>
                <div class="info-right">
                    <div class="banner-body">
                        <el-carousel :autoplay="false" arrow="always" @change="changeCar" indicator-position="none"  type="card" height="109px">
                            <el-carousel-item style="height: 109px" v-for="item in info.signboard.imgList1" :key="item">
                                <el-image class="qie-img" :src="item.img.url" fit="cover"></el-image>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="user-body">
                        <div class="user-title" @click="$router.go(-1)">返回到招牌享阅“{{info.signboard.title}}”</div>
                        <el-image class="head-img" :src="info.head_url" fit="cover"></el-image>
                    </div>
                    <div class="title-t">{{info.signboard.imgList1[showIndex].title}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Topheader from "../components/header"; //上传图片
    export default {
        components: {
            Topheader
        },
        name: "ldzgInfo",
        data() {
            return {
                id: '',
                showIndex:0,
                info:{
                    signboard:{
                        imgList1:[]
                    }
                },
            };
        },
        created() {
            document
                .querySelector("body")
                .setAttribute("style", "background-color:#494949");
            this.id=this.$route.query.id;
            this.getInfo();
        },
        //方法定义
        methods: {
            changeCar(e){
                this.showIndex=e;
            },
            getInfo(){
                let _this=this;
                _this.common.request('api/dynamic/info',{id:_this.id},function (res) {
                    if(res.status == 200){
                        _this.info=res.data.info;
                    }
                })
            }
        }
    }
</script>

<style scoped lang='less' rel="stylesheet/less">

    .info-body{
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
    }

    .user-body{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 60px;
    }

    .user-title{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        cursor: pointer;
    }
    .user-title:hover{
        color:rgba(255,255,255,0.8);

    }
    .head-img{
        width:48px;
        height:48px;
        border-radius:50%;
        margin-left: 16px;
    }

    .banner-body{
        height: 109px;
        overflow: hidden;
    }

    .title-t{
        font-size:24px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:54px;
        margin-top: 30px;
    }

    .info-left{
        width:462px;
        height:628px;
        display: flex;
        align-items: center;
    }

    .info-right{
        width: 600px;
    }

    .big-img{
        width:462px;
    }

    .el-carousel__item .qie-img {
        height: 109px;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
    .el-image{

    }

</style>


// WEBPACK FOOTER //
// src/view/ldzgInfo.vue